<button class="new_client_mobile_button" v-if="!isShowFilters && isShowNewClientButton" @click="$router.push('/client/create')">{{$t('clients.add_client')}}</button>
<div :class="isShowFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile'">
    <div class="filter_wrapper">
        <v-select class="small_filter_input mr-4 mt-2" v-model="filterSex" :label="'clients.inclub.sex'" :items="sex" @update:modelValue="applyFilter" clearable></v-select>
        <v-select class="small_filter_input mt-2" v-model="filterVip" :label="'clients.inclub.vip'" :items="vip" @update:modelValue="applyFilter" clearable></v-select>
    </div>
    <div><p @click="clearAllFilters" class="clear_all_filters pl-2">{{$t('clients.clear_all_filters')}}</p></div>
</div>

<button class="filter_button" @click="isShowFilters = !isShowFilters">{{ !isShowFilters ? $t('clients.filter') : $t('clients.hide')}} <img v-show="!isShowFilters" src="/assets/img/filter.svg" /></button>

<div class="mt-3 total_wrapper">
    <p class="total pl-2" v-show="isLoad"></p>
    <p class="total pl-2" v-show="!isLoad">{{$t('clients.total')}}: {{tableData.length}}</p>
    <div>
        <a v-if="isShowNewClientButton" class="new_client" @click="$router.push('/client/create')">{{$t('clients.add_client')}}</a>
        <a v-if="isShowDownloadButton" class="load" @click="downloadFile">{{$t('clients.load')}}</a>
        <a v-show="false" ref="download"></a>
    </div>

</div>

<div class="mt-2 table_wrapper">
    <v-datatable class="pointer" :columTemplates="columTemplates" :data="tableData" :isLoading="isLoad" @clickOnRow="openClient"></v-datatable>
</div>

